import React, { useState, useEffect } from 'react'
import contentdata from '../assets/contentdata.json'
import { Link } from "react-router-dom";
import Youtubeembed from '../components/Youtubeembed';


const YanchaKidsInitiation = () => {
    const [spcontent, setSpcontent] = useState({})

    useEffect(() => {
        setSpcontent(contentdata.kids_initiation_sp)
    }, [])

    return (
        <div>
            <div className='spacer'>
                <p className='brand-text large-gradient-heading'>{spcontent.title}</p>
            </div>
            <div className='spacer'>
                <p className='brand-text txt-survey'>{spcontent.short_content}</p>
            </div>
            <div className='spacer'>
                <Youtubeembed videourl={spcontent.video} />
            </div>

            {/* featured section */}
            <div className='grid grid-cols-2 gap-2 spacer'>
                <div>
                    <div className='border-solid border-gray border-[1px] rounded p-2 h-full'>
                        <div className='shiny-box'>
                            <p className='border15px sub-heading brand-font h-1/3'>Program Price</p>

                            <div className='flex flex-row test justify-between h-2/3 bottom15px '>
                                <div className='flex flex-col justify-end'>
                                    <p className='brand-font text-left bottom15px'>₹</p>
                                    <p className='brand-font text-[12px] text-left'>+ taxes as applicable</p>
                                </div>
                                <div className='flex flex-col justify-end'>
                                    <p className='brand-text text-[50px] text-right special-gradient-size large-gradient-heading'>{spcontent.program_price}</p>
                                    <p className='brand-font text-[16px] text-right'>only</p>
                                </div>
                            </div>

                            <div className='flex h-1/2 justify-center'>
                                <button className='p-2 rounded bg-green-500'>
                                    <p className='txt-inverse brand-font'>BUY NOW</p>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                <div className='flex flex-col gap-2'>
                    <div className='border-solid border-gray border-[1px] rounded p-2 h-1/2 flex items-center'>
                        <p className='brand-font text-[16px]'>{spcontent.highlight1}</p>
                    </div>
                    <div className='border-solid border-gray border-[1px] rounded p-2 h-1/2 flex items-center'>
                        <p className='brand-font text-[16px]'>{spcontent.highlight2}</p>
                    </div>
                </div>


            </div>

            {/* content */}
            <div className='spacer'>
                <p className='brand-text bottom7px txt-heading-large'>Requirements :</p>
                <ul>
                    <li className='brand-text txt'>✨ Multimedia enabled computer, good internet bandwidth</li>
                    <li className='brand-text txt'>✨ Medium of Instruction : English</li>
                </ul>
            </div>

            <div className='spacer'>
                <p className='brand-text bottom7px txt-heading-large'>What do you get ?</p>
                <ul>
                    <li className='brand-text txt'>✨ 1x Program Video covering the contents</li>
                    <li className='brand-text txt'>✨ 1x Yancha Case Study 1</li>
                    <li className='brand-text txt'>✨ 1x Workbook</li>
                    <li className='brand-text txt'>✨ Limited email and WhatsApp interactions with Yancha Guide</li>
                    <li className='brand-text txt'>✨ discount coupon for the future courses and learning for a lifetime</li>
                </ul>
            </div>

            <div className='spacer'>
                <p className='brand-text bottom7px txt-heading-large'>Program Objectives :</p>
                <ul>
                    <li className='brand-text txt'>✨ Identify the right approach to parenting</li>
                    <li className='brand-text txt'>✨ Assess yourself – mindset and beliefs for parenting</li>
                    <li className='brand-text txt'>✨ Use the right parenting style</li>
                    <li className='brand-text txt'>✨ Understand your child</li>
                    <li className='brand-text txt'>✨ Integrate child in all aspects of your life</li>
                </ul>
            </div>

            <div className='spacer'>
                <p className='brand-text bottom7px txt-heading-large'>Contents :</p>
                <ul>
                    <li className='brand-text txt'>✨ Responsibility of a parent</li>
                    <li className='brand-text txt'>✨ Tasks of Parents</li>
                    <li className='brand-text txt'>✨ Reorganizing your life</li>
                    <li className='brand-text txt'>✨ Developing a child</li>
                    <li className='brand-text txt'>✨ Parenting styles</li>
                    <li className='brand-text txt'>✨ Positive Psychology – PERMA Model</li>
                    <li className='brand-text txt'>✨ Generational gap</li>
                    <li className='brand-text txt'>✨ Understand your child</li>
                    <li className='brand-text txt'>✨ Integrate child in all aspects of your life</li>
                </ul>
            </div>

        </div>
    )
}

export default YanchaKidsInitiation